/* ══════════════════════════════════════════════════════════════════════════════
   SIGNAL RICERCA — la lente, dentro il negozio del cliente.

   Nessuna libreria, nessuna dipendenza. Gira sul sito di un cliente, dove qualunque cosa
   aggiunta è una cosa che può rompersi e che non possiamo aggiustare da qui.

   SEI DECISIONI CHE VALE LA PENA CONOSCERE PRIMA DI CAMBIARE QUALCOSA.

   1. LA RICERCA DEL TEMA NON SI ROMPE MAI. Si intercetta il clic sulla lente, e in fondo al
      riquadro c'è sempre «Usa la ricerca del negozio»: se il nostro non capisce, l'altro è a
      un tocco. Sostituire una funzione del sito di qualcun altro senza lasciare la via di
      ritorno è il modo di far perdere ordini a un cliente e scoprirlo dal suo fatturato.

   2. SI AGGANCIA A QUELLO CHE TROVA, E SE NON TROVA NIENTE LO DICE IN CONSOLE. I temi
      disegnano la ricerca in dieci modi. Quando nessuno c'è, chi installa deve saperlo —
      altrimenti prova il sito, non vede niente, e pensa che l'app sia rotta.

   3. IL RIQUADRO È UNA CONVERSAZIONE, NON UN MODULO. La domanda resta fissata sotto il
      titolo e la risposta sta sotto di lei; una seconda domanda si aggiunge in fondo con la
      sua risposta e i suoi capi. Prima ogni ricerca cancellava la precedente, e chi
      affinava perdeva quello che aveva appena visto.
      **Ogni turno è una ricerca, e costa un credito al negozio.** Non è una chat: non si
      risponde a domande sul negozio, si cerca. Le domande («questo arriva entro sabato?»)
      sono dell'Assistente e-commerce, che è un'altra app.

   4. NON SI CERCA MENTRE SI SCRIVE. Una ricerca per ogni lettera digitata moltiplicherebbe
      per venti il conto di una frase. Si cerca su Invio o sul pulsante.

   5. LA FOTO SI RIMPICCIOLISCE QUI, prima di partire. Rende il caricamento istantaneo anche
      in 4G — ma soprattutto è meno dato che esce dal telefono di chi sta comprando.

   6. IL «+» USA LA VARIANTE CHE HA SCELTO IL SERVER. È quella comprabile che ha fatto
      passare il capo al filtro: su un prodotto in cui la S è finita e la M c'è, aggiungere
      «la prima» manderebbe al carrello la S.
   ══════════════════════════════════════════════════════════════════════════════ */

(function () {
  "use strict";

  var posto = document.querySelector("[data-signal-ricerca]");
  if (!posto || posto.dataset.montato) return;
  posto.dataset.montato = "1";

  var BASE = "https://" + (posto.dataset.dominio || "signal.editstudio.agency");
  var NEGOZIO = posto.dataset.negozio || "";
  /* Il nome del negozio in alto a sinistra: senza, il riquadro sembra di qualcun altro
     aperto sopra il sito. Se il tema non lo passa si ripiega sul dominio senza suffissi. */
  var NOME = (posto.dataset.nome || "").trim() || NEGOZIO.replace(/\.myshopify\.com$/, "");
  var VALUTA = posto.dataset.valuta || "EUR";
  var INTERCETTA = posto.dataset.intercetta !== "false";
  /* L'ASPETTO. Dal 21/10 il riquadro si apre come un pannello in alto, con la risposta a sinistra
     e una fila di capi a destra. Il disegno di prima (foglio a colonna, con la conversazione che
     scende) si riprende con `data-aspetto="classico"` sul posto, senza toccare altro. */
  var CLASSICO = posto.dataset.aspetto === "classico";
  if (!NEGOZIO) return;

  var LATO_MAX = 1100;
  var config = null, gettone = null, dialogo = null, attributi = null, ultimaFrase = "", turni = 0;

  /* ── le icone ───────────────────────────────────────────────────────────── */
  var STELLA = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2C12.3 5.5 16.5 9.7 20 10C16.5 10.3 12.3 14.5 12 18C11.7 14.5 7.5 10.3 4 10C7.5 9.7 11.7 5.5 12 2Z" fill="currentColor"/></svg>';
  var CHIUDI = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var SU = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
  var MACCHINA = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8.5A1.5 1.5 0 014.5 7h2L8 5h8l1.5 2h2A1.5 1.5 0 0121 8.5v9A1.5 1.5 0 0119.5 19h-15A1.5 1.5 0 013 17.5v-9z"/><circle cx="12" cy="13" r="3.4"/></svg>';

  /* ── servizio ───────────────────────────────────────────────────────────── */
  function url(rotta) { return BASE + "/api/ricerca/pubblico/" + rotta + "?shop=" + encodeURIComponent(NEGOZIO); }
  function parla(rotta, corpo) {
    return fetch(url(rotta), {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Signal-Gettone": gettone || "" },
      body: JSON.stringify(corpo || {}),
    }).then(function (r) { return r.json().catch(function () { return { ok: false, errore: "Risposta non leggibile." }; }); });
  }
  function esc(t) {
    return String(t == null ? "" : t).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function soldi(n) {
    try { return new Intl.NumberFormat(document.documentElement.lang || "it", { style: "currency", currency: VALUTA, maximumFractionDigits: 0 }).format(n); }
    catch (e) { return n + " " + VALUTA; }
  }
  function el(html) { var d = document.createElement("div"); d.innerHTML = html; return d.firstElementChild; }

  /* ── IL CARATTERE E LE MISURE DEL TEMA ───────────────────────────────────
     `font: inherit` da solo non basta: eredita la famiglia, non il CORPO di base né il modo
     in cui quel negozio scrive i nomi dei prodotti. Su un tema con corpo 18 il nostro
     riquadro restava a 14 e si vedeva che era di qualcun altro.

     Si leggono tre cose dal sito vero e si scrivono come variabili sul foglio; il CSS è
     tutto in `em` su quelle. Se una lettura non riesce resta il ripiego dichiarato nel CSS:
     meglio una misura nostra che un riquadro senza testo. */
  function tipografiaDalTema(foglio) {
    try {
      var b = getComputedStyle(document.body);
      if (b.fontFamily) foglio.style.setProperty("--rc-font", b.fontFamily);
      /* Il corpo di base si prende dal `body`, ma con un freno: sotto 13 il riquadro
         diventa illeggibile e sopra 20 ci sta dentro mezza parola per riga. Un tema con
         misure estreme non deve poter rompere il nostro, solo colorarlo. */
      var base = parseFloat(b.fontSize);
      if (base >= 13 && base <= 20) foglio.style.setProperty("--rc-base", base + "px");

      /* Come il tema scrive i NOMI dei prodotti: è la riga che si ripete di più nel
         riquadro, ed è quella che fa sembrare le schede sue o nostre. */
      var card = document.querySelector(
        ".card__heading, .card-information__text, .product-card__title, .grid-product__title, .card__information .full-unstyled-link");
      if (card) {
        var c = getComputedStyle(card);
        if (c.textTransform) foglio.style.setProperty("--rc-nome-trasf", c.textTransform);
        if (c.letterSpacing && c.letterSpacing !== "normal") foglio.style.setProperty("--rc-nome-spazio", c.letterSpacing);
        if (c.fontWeight) foglio.style.setProperty("--rc-nome-peso", c.fontWeight);
      }
      /* Il peso del titolo grande: dal titolo del prodotto del tema, non deciso da noi. */
      var h = document.querySelector(".product__title, .product-title, h1");
      if (h) {
        var hs = getComputedStyle(h);
        if (hs.fontWeight) foglio.style.setProperty("--rc-titolo-peso", hs.fontWeight);
      }
    } catch (e) { /* stili non leggibili: restano i ripieghi del CSS */ }
  }

  /* ── apertura e chiusura ────────────────────────────────────────────────── */
  function apri(fraseIniziale) {
    if (dialogo) { if (fraseIniziale) manda(fraseIniziale); return; }
    if (!config || !config.acceso) return;
    turni = 0; attributi = null;
    dialogo = document.createElement("div");
    dialogo.className = "signal-rc-velo" + (CLASSICO ? "" : " signal-rc-nuovo");
    dialogo.setAttribute("role", "dialog");
    dialogo.setAttribute("aria-modal", "true");
    dialogo.setAttribute("aria-label", "Ricerca");
    dialogo.addEventListener("click", function (e) { if (e.target === dialogo) chiudi(); });
    document.addEventListener("keydown", tasto);
    document.documentElement.style.overflow = "hidden";
    document.body.appendChild(dialogo);
    disegna();
    if (fraseIniziale) manda(fraseIniziale);
    else { var i = dialogo.querySelector(".signal-rc-domanda input"); if (i) i.focus(); }
  }
  function chiudi() {
    if (!dialogo) return;
    document.removeEventListener("keydown", tasto);
    document.documentElement.style.overflow = "";
    dialogo.remove();
    dialogo = null; attributi = null; turni = 0;
  }
  function tasto(e) { if (e.key === "Escape") chiudi(); }
  var corpo = function () { return dialogo && dialogo.querySelector(".signal-rc-corpo"); };

  /* ── la struttura ───────────────────────────────────────────────────────── */
  function disegna() {
    dialogo.innerHTML =
      '<div class="signal-rc-foglio">' +
        '<header class="signal-rc-testa">' +
          '<span class="signal-rc-marchio">' + esc(NOME) + "</span>" +
          '<button type="button" class="signal-rc-x" aria-label="Chiudi">' + CHIUDI + "</button>" +
        "</header>" +
        '<div class="signal-rc-corpo">' +
          '<h1 class="signal-rc-titolo">Cerca</h1>' +
          /* All'inizio la domanda È il campo. Dopo la prima ricerca lo stesso posto diventa
             l'intestazione con la frase: il campo scende in fondo (vedi `fissaDomanda`). */
          '<div class="signal-rc-domanda">' +
            '<span class="signal-rc-stella">' + STELLA + "</span>" +
            '<input type="search" enterkeyhint="search" autocomplete="off" aria-label="Cerca" placeholder="' + esc(config.invito || "Cosa cerchi?") + '">' +
            (!CLASSICO && config.daFoto ? '<button type="button" class="signal-rc-foto" aria-label="Cerca da una foto">' + MACCHINA + "</button>" : "") +
          "</div>" +
          '<div class="signal-rc-turni"></div>' +
        "</div>" +
        (CLASSICO ? '<div class="signal-rc-fondo" hidden>' +
          '<div class="signal-rc-composer">' +
            '<span class="signal-rc-stella">' + STELLA + "</span>" +
            '<input type="search" enterkeyhint="search" autocomplete="off" aria-label="Affina la ricerca" placeholder="Affina, o chiedi altro…">' +
            (config.daFoto ? '<button type="button" class="signal-rc-foto" aria-label="Cerca da una foto">' + MACCHINA + "</button>" : "") +
            '<button type="button" class="signal-rc-invia" aria-label="Cerca" disabled>' + SU + "</button>" +
          "</div>" +
        "</div>" : "") +
        (CLASSICO
          ? '<div class="signal-rc-pie"><span>Ricerca di SIGNAL</span>' +
            '<button type="button" class="signal-rc-tema">Usa la ricerca del negozio</button></div>'
          : '<div class="signal-rc-pie">' +
            '<button type="button" class="signal-rc-tema">Vedi tutti i risultati <i aria-hidden="true">→</i></button>' +
            '<button type="button" class="signal-rc-continua">Affina o chiedi altro <i aria-hidden="true">→</i></button></div>') +
      "</div>";

    var f = dialogo.firstChild;
    tipografiaDalTema(f);
    f.querySelector(".signal-rc-x").addEventListener("click", chiudi);
    f.querySelector(".signal-rc-tema").addEventListener("click", function () {
      // Con quello che era già stato scritto: ricominciare da capo è il motivo per cui una
      // via d'uscita non viene usata.
      location.href = "/search?q=" + encodeURIComponent(ultimaFrase || valore(".signal-rc-domanda input"));
    });

    agganciaCampo(".signal-rc-domanda input");
    agganciaCampo(".signal-rc-composer input");
    var continua = f.querySelector(".signal-rc-continua");
    if (continua) continua.addEventListener("click", function () {
      var i = f.querySelector(".signal-rc-domanda input");
      if (i) { i.focus(); i.select(); }
    });
    var invia = f.querySelector(".signal-rc-invia");
    if (invia) invia.addEventListener("click", function () { manda(valore(".signal-rc-composer input")); });
    var foto = f.querySelector(".signal-rc-foto");
    if (foto) foto.addEventListener("click", scegliFoto);

    inizio();
  }

  function valore(sel) { var i = dialogo && dialogo.querySelector(sel); return i ? i.value.trim() : ""; }

  function agganciaCampo(sel) {
    var i = dialogo.querySelector(sel);
    if (!i) return;
    i.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); manda(i.value.trim()); } });
    i.addEventListener("input", function () {
      var b = dialogo.querySelector(".signal-rc-invia");
      if (b) b.disabled = !valore(".signal-rc-composer input");
    });
  }

  /* Dopo la prima domanda il campo in alto diventa l'intestazione, e quello in fondo appare.
     È la differenza fra un modulo da compilare e una conversazione. */
  function fissaDomanda(frase) {
    if (!CLASSICO) {
      /* Nel pannello nuovo il campo resta un campo: la frase ci rimane scritta e si corregge
         sul posto. Non c'è più il campo in fondo da far comparire. */
      var campo = dialogo.querySelector(".signal-rc-domanda input");
      if (campo) campo.value = frase;
      return;
    }
    var d = dialogo.querySelector(".signal-rc-domanda");
    d.className = "signal-rc-domanda signal-rc-fissata";
    d.innerHTML = '<span class="signal-rc-stella">' + STELLA + '</span><span class="t">' + esc(frase) + "</span>";
    dialogo.querySelector(".signal-rc-fondo").hidden = false;
  }

  /* ── lo stato iniziale ──────────────────────────────────────────────────── */
  function inizio() {
    var c = dialogo.querySelector(".signal-rc-turni");
    var v = config.vocabolario || {};
    var h = "";
    if (config.frequenti && config.frequenti.length) {
      h += '<p class="signal-rc-titoletto">Cercano anche</p><div class="signal-rc-recenti">' +
        config.frequenti.map(function (t) { return '<button type="button" data-frase="' + esc(t) + '">' + esc(t) + "</button>"; }).join("") + "</div>";
    }
    if (v.occasioni && v.occasioni.length) {
      h += '<p class="signal-rc-titoletto">Per cosa</p><div class="signal-rc-elenco">' +
        v.occasioni.slice(0, 6).map(function (t) { return '<button type="button" data-frase="' + esc(t) + '">' + esc(t) + "</button>"; }).join("") + "</div>";
    }
    if (v.categorie && v.categorie.length) {
      h += '<p class="signal-rc-titoletto">Cosa</p><div class="signal-rc-elenco">' +
        v.categorie.slice(0, 10).map(function (t) { return '<button type="button" data-frase="' + esc(t) + '">' + esc(t) + "</button>"; }).join("") + "</div>";
    }
    c.innerHTML = h || '<p class="signal-rc-attesa">Scrivi cosa cerchi, come lo diresti a voce.</p>';
    frasi(c);
  }
  function frasi(c) {
    c.querySelectorAll("[data-frase]").forEach(function (b) {
      b.addEventListener("click", function () { manda(b.dataset.frase); });
    });
  }

  /* ── un turno: domanda, risposta, capi ──────────────────────────────────── */
  function manda(frase) {
    if (!frase || frase.length < 2 || !config.aParole) return;
    var i = dialogo.querySelector(".signal-rc-composer input");
    if (i) { i.value = ""; var b = dialogo.querySelector(".signal-rc-invia"); if (b) b.disabled = true; }
    cerca(frase);
  }

  function cerca(frase) {
    ultimaFrase = frase;
    attributi = null;
    /* Nel pannello nuovo ogni ricerca sostituisce la precedente: c'è una risposta e una fila di
       capi, non una conversazione che scende. Nel disegno classico si accumulano. */
    if (turni === 0 || !CLASSICO) { dialogo.querySelector(".signal-rc-turni").innerHTML = ""; fissaDomanda(frase); }
    else aggiungi('<div class="signal-rc-mia"><span>' + esc(frase) + "</span></div>");
    turni++;
    var attesa = aggiungi('<p class="signal-rc-attesa">Sto cercando…</p>');

    parla("cerca", { frase: frase }).then(function (r) {
      // Una risposta vecchia che arriva dopo una ricerca nuova non deve sovrascriverla.
      if (ultimaFrase !== frase || !dialogo) return;
      attesa.remove();
      if (!r || !r.ok) return aggiungi('<p class="signal-rc-errore">' + esc((r && r.errore) || "Non ci sono riuscito.") + "</p>");
      turno({
        riga: r.riga,
        note: (r.allentato || []).map(function (a) { return a.detto; })
          .concat(r.capito === false ? ["Non ho capito bene la frase: ho cercato le parole nei nomi dei capi."] : []),
        risultati: r.risultati,
        totale: r.totale,
        trovati: r.trovati,
        sfaccettature: r.sfaccettature,
        frase: frase,
      });
    }).catch(function () {
      attesa.remove();
      aggiungi('<p class="signal-rc-errore">Non ci sono riuscito: riprova fra un momento.</p>');
    });
  }

  function aggiungi(html) {
    var n = el(html);
    dialogo.querySelector(".signal-rc-turni").appendChild(n);
    n.scrollIntoView({ block: "nearest" });
    return n;
  }

  function turno(d) {
    /* LA RISPOSTA PRIMA DEI CAPI, e gli allentamenti dentro la stessa bolla. Sono la parte
       che spiega perché sotto c'è quello che c'è: staccarli dalla risposta vorrebbe dire
       lasciarli leggere a chi è già sceso fra le schede, cioè a nessuno. */
    /* LA RIGA DEL SERVER CONTIENE GIÀ GLI ALLENTAMENTI IN CODA — `riga()` li unisce al
       conteggio perché chi la usa altrove ha una frase sola. Qui invece gli allentamenti
       hanno un posto loro, sotto, in grigio: aggiungerli senza toglierli dalla riga li
       faceva uscire DUE VOLTE nella stessa bolla. Si sottraggono per stringa esatta, non
       tagliando al primo punto: una frase come «sotto 300 €.» ha punti dentro. */
    var testa = String(d.riga || "");
    (d.note || []).forEach(function (n) { testa = testa.split(n).join(" "); });
    testa = testa.replace(/\s+/g, " ").trim();
    var bolla = (testa ? "<p>" + esc(testa) + "</p>" : "") +
      (d.note || []).map(function (n) { return "<p>" + esc(n) + "</p>"; }).join("");
    aggiungi('<div class="signal-rc-risposta"><span class="signal-rc-avatar">' + STELLA + "</span>" +
      '<div class="signal-rc-bolla">' + bolla + "</div></div>");

    var esatti = (d.risultati || []).filter(function (x) { return x.esatto !== false; });
    var simili = (d.risultati || []).filter(function (x) { return x.esatto === false; });

    if (esatti.length) {
      var quanti = typeof d.trovati === "number" ? d.trovati : esatti.length;
      metaErisultati(quanti === 1 ? "1 risultato" : quanti + " risultati", esatti, d.sfaccettature, d.frase);
    }
    if (simili.length) {
      /* La riga che divide. Disegnare i somiglianti come gli esatti vorrebbe dire spacciare
         un ripiego per una risposta, e il momento in cui qualcuno se ne accorge è quando
         apre il capo e non è quello che cercava. */
      metaErisultati(esatti.length ? "Gli somigliano" : "Quello che ho", simili, null, d.frase);
    }
    if (!esatti.length && !simili.length && d.spinte === undefined) {
      aggiungi('<p class="signal-rc-attesa">Non ho niente di comprabile che ci assomigli.</p>');
    }
  }

  function metaErisultati(etichetta, lista, sfacc, frase) {
    aggiungi('<div class="signal-rc-meta"><span>' + (sfacc ? "Affina" : "") + '</span>' +
      '<span class="conta">' + esc(etichetta) + "</span></div>");

    /* I FILTRI SI VEDONO SUBITO. Per un giro sono stati dietro un pulsante «Filtra»:
       nascosti così non li tocca nessuno, e sono le parole che il catalogo ha davvero sotto
       QUESTI risultati — servono proprio a chi li sta guardando adesso. */
    if (sfacc) {
      var pannello = aggiungi('<div class="signal-rc-filtri">' + filtri(sfacc, frase) + "</div>");
      frasi(pannello);
    }
    var fila = aggiungi('<div class="signal-rc-fila">' + lista.map(carta).join("") + "</div>");
    fila.querySelectorAll(".signal-rc-aggiungi, .signal-rc-agg").forEach(function (b) {
      b.addEventListener("click", function () {
        var v = Number(b.dataset.variante);
        if (!v) {
          // Niente taglia scelta: si dice cosa manca invece di non fare niente.
          var tg = b.closest(".signal-rc-capo").querySelector(".signal-rc-taglie");
          if (tg) tg.classList.add("signal-rc-scegli");
          avvisa("Scegli prima la taglia.");
          return;
        }
        alCarrello(v, b);
      });
    });
    fila.querySelectorAll(".signal-rc-taglia").forEach(function (b) {
      b.addEventListener("click", function () {
        if (b.disabled) return;
        var capo = b.closest(".signal-rc-capo");
        capo.querySelectorAll(".signal-rc-taglia").forEach(function (o) { o.classList.remove("on"); o.setAttribute("aria-pressed", "false"); });
        b.classList.add("on"); b.setAttribute("aria-pressed", "true");
        var tg = capo.querySelector(".signal-rc-taglie"); if (tg) tg.classList.remove("signal-rc-scegli");
        var a = capo.querySelector(".signal-rc-agg");
        if (a) { a.dataset.variante = b.dataset.var; a.disabled = false; a.textContent = "Aggiungi"; }
      });
    });
    fila.querySelectorAll("[data-spinta]").forEach(function (b) {
      b.addEventListener("click", function () { affina(JSON.parse(b.dataset.spinta)); });
    });
  }

  /* I filtri sono le sfaccettature VERE dei risultati, e raffinano la frase invece di
     sostituirla: «abito rosso» + «cerimonia» cerca «abito rosso cerimonia». Sostituirla
     farebbe ricominciare da zero, che è il contrario di affinare. */
  function filtri(s, frase) {
    var gruppo = function (titolo, voci) {
      if (!voci || !voci.length) return "";
      return '<div class="signal-rc-gruppo"><b>' + esc(titolo) + "</b>" + voci.slice(0, 6).map(function (x) {
        return '<button type="button" class="signal-rc-voce" data-frase="' + esc(frase + " " + x.valore) + '">' + esc(x.valore) + " (" + x.quanti + ")</button>";
      }).join("") + "</div>";
    };
    var h = gruppo("Colore", s.colori) + gruppo("Per cosa", s.occasioni) + gruppo("Cosa", s.categorie);
    return h || '<p class="signal-rc-attesa" style="padding:4px 0">Niente su cui filtrare.</p>';
  }

  function carta(x) {
    if (!CLASSICO) return cartaNuova(x);
    return (
      '<div class="signal-rc-capo">' +
        '<a href="' + esc(x.url) + '">' +
          (x.immagine ? '<img src="' + esc(x.immagine) + '" alt="' + esc(x.titolo) + '" loading="lazy">' : '<span class="signal-rc-vuota"></span>') +
          (x.somiglianza != null ? '<span class="signal-rc-match">' + x.somiglianza + "%</span>" : "") +
          '<span class="signal-rc-marca">' + esc(x.categoria || NOME) + "</span>" +
          '<span class="signal-rc-nome">' + esc(x.titolo) + "</span>" +
          '<span class="signal-rc-prezzo">' + esc(soldi(x.prezzo)) + "</span>" +
          (x.nota && x.nota.length ? '<span class="signal-rc-perche">' + esc(x.nota.slice(0, 3).join(" · ")) + "</span>" : "") +
        "</a>" +
        (x.variante ? '<button type="button" class="signal-rc-aggiungi" data-variante="' + x.variante + '" aria-label="Aggiungi al carrello">+</button>' : "") +
      "</div>"
    );
  }

  /* LA CARTA DEL PANNELLO NUOVO: foto, le taglie sotto, nome e prezzo, e una scritta che dice cosa
     fa. Niente «+» tondo sulla foto: un segno senza parole non spiega di quale taglia parla. La
     taglia scelta decide la variante che va nel carrello; se il capo ha una taglia sola, o quella
     chiesta, è già scelta e si vede. */
  function cartaNuova(x) {
    var taglie = x.taglie || [];
    var compra = taglie.some(function (t) { return t.disponibile; }) || !!x.variante;
    var scelta = x.variante || "";
    var righe = taglie.length
      ? '<div class="signal-rc-taglie" role="group" aria-label="Taglia">' + taglie.map(function (t) {
          var on = t.disponibile && t.variante === x.variante;
          return '<button type="button" class="signal-rc-taglia' + (on ? " on" : "") + (t.disponibile ? "" : " no") + '" data-var="' + t.variante + '"' +
            (t.disponibile ? "" : ' disabled aria-disabled="true" title="Finita"') + ' aria-pressed="' + (on ? "true" : "false") + '">' + esc(t.etichetta) + "</button>";
        }).join("") + "</div>"
      : "";
    return (
      '<div class="signal-rc-capo">' +
        '<a class="signal-rc-lega" href="' + esc(x.url) + '">' +
          (x.immagine ? '<img src="' + esc(x.immagine) + '" alt="' + esc(x.titolo) + '" loading="lazy">' : '<span class="signal-rc-vuota"></span>') +
          (x.somiglianza != null ? '<span class="signal-rc-match">' + x.somiglianza + "%</span>" : "") +
        "</a>" +
        righe +
        '<a class="signal-rc-lega" href="' + esc(x.url) + '">' +
          '<span class="signal-rc-marca">' + esc(x.categoria || NOME) + "</span>" +
          '<span class="signal-rc-nome">' + esc(x.titolo) + "</span>" +
          '<span class="signal-rc-prezzo">' + esc(soldi(x.prezzo)) + "</span>" +
          (x.nota && x.nota.length ? '<span class="signal-rc-perche">' + esc(x.nota.slice(0, 3).join(" · ")) + "</span>" : "") +
        "</a>" +
        (compra ? '<button type="button" class="signal-rc-agg" data-variante="' + scelta + '" aria-label="Aggiungi al carrello">Aggiungi</button>' : "") +
      "</div>"
    );
  }

  /* ── la ricerca da foto ─────────────────────────────────────────────────── */
  function scegliFoto() {
    var inp = document.createElement("input");
    inp.type = "file";
    inp.accept = "image/jpeg,image/png,image/webp";
    /* `capture` NON si mette: su telefono aprirebbe sempre la fotocamera, e chi cerca da
       uno screenshot — il caso più frequente — non riuscirebbe a farlo. */
    inp.addEventListener("change", function () {
      var file = inp.files && inp.files[0];
      if (!file) return;
      if (turni === 0 || !CLASSICO) { dialogo.querySelector(".signal-rc-turni").innerHTML = ""; fissaDomanda("Da una foto"); }
      else aggiungi('<div class="signal-rc-mia"><span>Da una foto</span></div>');
      turni++;
      ultimaFrase = "";
      var attesa = aggiungi('<p class="signal-rc-attesa">Sto guardando la foto…</p>');
      rimpicciolisci(file)
        .then(function (r) { return parla("foto", { foto: r.base64, tipo: r.tipo }); })
        .then(function (r) {
          if (!dialogo) return;
          attesa.remove();
          if (!r || !r.ok) return aggiungi('<p class="signal-rc-errore">' + esc((r && r.errore) || "Non sono riuscito a leggere la foto.") + "</p>");
          attributi = r.attributi;
          turno({
            riga: r.letto,
            note: r.buco ? ["Nessuno di questi è molto vicino: sono i più simili che ho."] : [],
            risultati: r.risultati, trovati: (r.risultati || []).length, spinte: r.spinte, frase: "",
          });
          if (r.spinte && r.spinte.length) spinte(r.spinte);
        })
        .catch(function () { attesa.remove(); aggiungi('<p class="signal-rc-errore">Non sono riuscito a leggere la foto: riprova.</p>'); });
    });
    inp.click();
  }

  function spinte(lista) {
    var p = aggiungi('<div class="signal-rc-filtri"><div class="signal-rc-gruppo"><b>Correggi</b>' +
      lista.map(function (s) { return '<button type="button" class="signal-rc-voce" data-spinta=\'' + esc(JSON.stringify(s)) + "'>" + esc(s.etichetta) + "</button>"; }).join("") +
      "</div></div>");
    p.querySelectorAll("[data-spinta]").forEach(function (b) {
      b.addEventListener("click", function () { affina(JSON.parse(b.dataset.spinta)); });
    });
  }

  function affina(spinta) {
    if (!attributi) return;
    if (CLASSICO) aggiungi('<div class="signal-rc-mia"><span>' + esc(spinta.etichetta) + "</span></div>");
    else dialogo.querySelector(".signal-rc-turni").innerHTML = "";
    var attesa = aggiungi('<p class="signal-rc-attesa">Sto rifacendo la ricerca…</p>');
    parla("affina", { attributi: attributi, spinta: spinta }).then(function (r) {
      if (!dialogo) return;
      attesa.remove();
      if (!r || !r.ok) return aggiungi('<p class="signal-rc-errore">' + esc((r && r.errore) || "Non ci sono riuscito.") + "</p>");
      attributi = r.attributi;
      turno({
        riga: r.letto,
        note: r.buco ? ["Nessuno di questi è molto vicino: sono i più simili che ho."] : [],
        risultati: r.risultati, trovati: (r.risultati || []).length, spinte: r.spinte, frase: "",
      });
      if (r.spinte && r.spinte.length) spinte(r.spinte);
    }).catch(function () { attesa.remove(); aggiungi('<p class="signal-rc-errore">Non ci sono riuscito.</p>'); });
  }

  function rimpicciolisci(file) {
    return new Promise(function (risolvi, rifiuta) {
      var lettore = new FileReader();
      lettore.onerror = function () { rifiuta(new Error("foto non leggibile")); };
      lettore.onload = function () {
        var img = new Image();
        img.onerror = function () { rifiuta(new Error("foto non valida")); };
        img.onload = function () {
          try {
            var scala = Math.min(1, LATO_MAX / Math.max(img.width, img.height));
            var tela = document.createElement("canvas");
            tela.width = Math.max(1, Math.round(img.width * scala));
            tela.height = Math.max(1, Math.round(img.height * scala));
            tela.getContext("2d").drawImage(img, 0, 0, tela.width, tela.height);
            var dati = tela.toDataURL("image/jpeg", 0.82);
            var virgola = dati.indexOf(",");
            if (virgola < 0) return rifiuta(new Error("conversione non riuscita"));
            risolvi({ base64: dati.slice(virgola + 1), tipo: "image/jpeg" });
          } catch (e) { rifiuta(e); }
        };
        img.src = String(lettore.result);
      };
      lettore.readAsDataURL(file);
    });
  }

  /* ── il carrello ────────────────────────────────────────────────────────── */
  function alCarrello(variante, bottone) {
    if (!variante) return;
    var prima = bottone.textContent;
    var scritta = String(bottone.className || "").indexOf("signal-rc-agg") > -1 ? "Aggiunto ✓" : "✓";
    bottone.disabled = true;
    bottone.textContent = "…";
    fetch("/cart/add.js", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variante, quantity: 1 }] }),
    }).then(function (r) {
      if (!r.ok) throw new Error("rifiutato");
      bottone.textContent = scritta;
      /* Il tema non sa che il carrello è cambiato: il suo numerino resta fermo finché non si ricarica,
         e chi ha premuto «Aggiungi» crede che non sia successo niente. La conferma dice cosa è
         andato nel carrello e porta al carrello con un tocco. */
      avvisa("Aggiunto al carrello.", "/cart");
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      try { document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true })); } catch (e) { /* tema senza eventi */ }
    }).catch(function () {
      // Un «+» che non fa niente e non spiega è peggio di nessun «+».
      bottone.disabled = false;
      bottone.textContent = prima;
      avvisa("Non sono riuscito ad aggiungerlo: apri la scheda del capo.");
    });
  }

  function avvisa(testo, vaiA) {
    var t = document.createElement("div");
    t.textContent = testo;
    t.setAttribute("role", "status");
    t.style.cssText = "position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483001;" +
      "background:#0e0f12;color:#fff;padding:12px 18px;border-radius:999px;font-size:14px;max-width:92vw;text-align:center";
    if (vaiA) {
      var a = document.createElement("a");
      a.href = vaiA; a.textContent = "Vedi il carrello \u2192";
      a.style.cssText = "color:#fff;text-decoration:underline;margin-left:14px;white-space:nowrap";
      t.appendChild(a);
    }
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, vaiA ? 7000 : 3600);
  }

  /* ── l'aggancio alla lente del tema ────────────────────────────────────── */
  function aggancia() {
    if (!INTERCETTA) return 0;
    var trovati = 0;
    var suo = (posto.dataset.apre || "").trim();
    var selettori = suo ? [suo] : [
      'a[href="/search"]', 'a[href^="/search?"]', 'a[href$="/search"]',
      "[data-signal-apre-ricerca]",
      'summary[aria-label*="earch"]', 'summary[aria-label*="erca"]',
      'button[aria-label*="earch"]', 'button[aria-label*="erca"]',
    ];
    selettori.forEach(function (s) {
      document.querySelectorAll(s).forEach(function (e2) {
        if (e2.dataset.signalAgganciato) return;
        e2.dataset.signalAgganciato = "1";
        e2.addEventListener("click", function (ev) { ev.preventDefault(); ev.stopPropagation(); apri(""); }, true);
        trovati++;
      });
    });
    document.querySelectorAll('form[action*="/search"]').forEach(function (form) {
      if (form.dataset.signalAgganciato) return;
      form.dataset.signalAgganciato = "1";
      form.addEventListener("submit", function (ev) {
        var q = form.querySelector('input[name="q"]');
        var frase = q ? q.value.trim() : "";
        if (!frase) return;
        ev.preventDefault();
        apri(frase);
      });
      trovati++;
    });
    return trovati;
  }

  /* ── l'avvio ───────────────────────────────────────────────────────────── */
  fetch(url("avvio"), { method: "GET" })
    .then(function (r) { return r.json(); })
    .then(function (r) {
      if (!r || !r.ok || !r.acceso) return;
      config = r;
      gettone = r.gettone;
      var n = aggancia();
      /* I temi caricano l'intestazione anche dopo: si guarda per qualche secondo. Non per
         sempre — un osservatore che vive quanto la pagina è un costo su ogni scorrimento. */
      var osserva = new MutationObserver(function () { aggancia(); });
      osserva.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function () { osserva.disconnect(); }, 8000);

      if (INTERCETTA && !n) {
        console.warn("[SIGNAL Ricerca] Non ho trovato la lente di questo tema. Passa il selettore giusto: {% render 'signal-ricerca', apre: '.tuo-selettore' %} — oppure chiama SignalRicerca.apri() dal tuo pulsante.");
      }
    })
    .catch(function () { /* server non raggiungibile: la ricerca del tema resta quella di prima */ });

  window.SignalRicerca = { apri: function (frase) { apri(frase || ""); }, chiudi: chiudi };
})();
